import { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { ApiClient } from '../api/api-client';

export default function DisplayOnlyRoute() {
  const [auth, setAuth] = useState(null);
  const location = useLocation();

  useEffect(() => {
    ApiClient.getInstance()
      .getSession()
      .then((res) => {
        const isSystem = res.data.systemAccount === true;
        sessionStorage.setItem('userId', res.data.id);
        sessionStorage.setItem('username', res.data.name);
        sessionStorage.setItem('systemAccount', isSystem.toString());

        if (isSystem) {
          setAuth(true);
        } else {
          setAuth(false);
          sessionStorage.setItem('redirectAfterLogin', location.pathname + location.search);
        }

      })
      .catch(() => {
        setAuth(false);
        sessionStorage.setItem('redirectAfterLogin', location.pathname + location.search);
      });
  }, [location.pathname]);

  if (auth === null) return <div>Loading...</div>;

  if (auth === false) return <Navigate to="/" replace />;
  

  return <Outlet />;
}
